import type { ModifiersRouter } from "replo-publisher/src/trpc/routers/modifiers";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: modifiersRouter,
  client: modifiersClient,
  utils: modifiersUtils,
  options: modifiersOptions,
} = createTrpcRouterConfig<ModifiersRouter>({
  path: "modifiers",
  queryClient: getNamespacedQueryClient("modifiers"),
});

export { modifiersClient, modifiersRouter, modifiersUtils, modifiersOptions };
